import { Pagamento } from '../../../models/pagamento';

export class PagamentoAdapter {

  pagamento: Pagamento = new Pagamento();

constructor(pagamento: Pagamento) {
  this.pagamento.id = pagamento.id ;
  this.pagamento.dataPagamento = pagamento.dataPagamento ;
  this.pagamento.tipoPagamento = pagamento.tipoPagamento ?  JSON.parse(JSON.stringify(pagamento.tipoPagamento)) : null;
  this.pagamento.modalitaPagamento = pagamento.modalitaPagamento ?  JSON.parse(JSON.stringify(pagamento.modalitaPagamento)) : null;
  this.pagamento.motivo = pagamento.motivo ?  JSON.parse(JSON.stringify(pagamento.motivo)) : null;
  this.pagamento.tipoSommaLiquidata = pagamento.tipoSommaLiquidata ?  JSON.parse(JSON.stringify(pagamento.tipoSommaLiquidata)) : null;
  this.pagamento.terzoPignorato = pagamento.terzoPignorato ?  JSON.parse(JSON.stringify(pagamento.terzoPignorato)) : null;
  this.pagamento.numeroAutorizzazione = pagamento.numeroAutorizzazione ;
  this.pagamento.dataAutorizzazione = pagamento.dataAutorizzazione ;
  this.pagamento.importo = pagamento.importo ;
  this.pagamento.cpa = pagamento.cpa ?  JSON.parse(JSON.stringify(pagamento.cpa)) : null;
  this.pagamento.iva = pagamento.iva ?  JSON.parse(JSON.stringify(pagamento.iva)) : null;
  this.pagamento.sommaNonSoggettaRitenuta = pagamento.sommaNonSoggettaRitenuta ;
  this.pagamento.flagRitenutaAcconto = pagamento.flagRitenutaAcconto ? pagamento.flagRitenutaAcconto : false;
  this.pagamento.legaleIncaricato = pagamento.legaleIncaricato ?  JSON.parse(JSON.stringify(pagamento.legaleIncaricato)) : null;
  this.pagamento.controparte = pagamento.controparte ?  JSON.parse(JSON.stringify(pagamento.controparte)) : null;
  this.pagamento.altraParte = pagamento.altraParte ?  JSON.parse(JSON.stringify(pagamento.altraParte)) :  null;
  this.pagamento.note = pagamento.note ;
  this.pagamento.documenti = pagamento.documenti ?  JSON.parse(JSON.stringify(pagamento.documenti)) : null;
};

}
